module.exports = __webpack_public_path__ + "img/img_7266.7ea2ab82.jpg";